import { Voucher, VoucherTipo } from './voucher';

// MOCK. Espelha os 15 cupons cadastrados na retaguarda (`venda/voucher`), lidos em
// 2026-08-25. Existe porque a loja NAO alcanca voucher: `sirius-s` devolve 404 em todos
// os caminhos, enquanto o `sirius` pede autenticacao - e credencial nao pode ir no
// bundle, que roda no navegador do cliente.
//
// Sai inteiro quando existir `aps://integracao/voucher/{codigo}`: so o
// `voucherBusca()` do EcommerceService muda, e nenhuma tela e tocada.
//
// Atencao ao ler a lista da retaguarda: a coluna "Desconto" mostra R$ e % lado a lado,
// mas o cadastro tem UM tipo so. Para VOUCHER05 e VOUCHER06 a listagem exibia os dois
// valores e nao abri o cadastro de cada um - foram assumidos como Valor, seguindo o
// VOUCHER1010, cujo cadastro foi conferido (Tipo = Valor, R$ 5,00). Os dois estao
// vencidos desde 30/04/2024, entao a suposicao nao muda nada na pratica.
//
// Em 2026-08-25 apenas TRES estao dentro da validade: CAIO50, TOMA10 e INSTA5.
const CATALOGO: {
  codigo: string;
  nome: string;
  tipo: VoucherTipo;
  valor: number;
  inicio: string;
  conclusao: string;
}[] = [
  { codigo: 'CAIO50', nome: 'CAIO50', tipo: VoucherTipo.Percentual, valor: 50, inicio: '2026-02-26', conclusao: '2027-02-26' },
  { codigo: 'TOMA10', nome: 'TOMA10', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2025-06-25', conclusao: '2029-08-30' },
  { codigo: 'INSTA5', nome: 'STORIES LOJA INSTAGRAM', tipo: VoucherTipo.Percentual, valor: 5, inicio: '2024-05-04', conclusao: '2099-05-04' },
  { codigo: 'KEVINE10', nome: 'kevin', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2025-10-07', conclusao: '2025-10-07' },
  { codigo: '1000', nome: 'Promoção de Teste da Descrição Sobreposta', tipo: VoucherTipo.Percentual, valor: 5, inicio: '2025-06-27', conclusao: '2025-06-27' },
  { codigo: 'VOUCHER CH', nome: 'VOUCHER CH', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2025-06-17', conclusao: '2025-06-17' },
  { codigo: '0002', nome: 'Promo15', tipo: VoucherTipo.Percentual, valor: 15, inicio: '2024-11-08', conclusao: '2024-11-08' },
  { codigo: '0001', nome: 'promo10', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2024-09-23', conclusao: '2025-10-23' },
  { codigo: 'PROMOJADE01', nome: 'Promoção Jade 01', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2024-07-09', conclusao: '2024-07-09' },
  { codigo: 'VOUCHER1010', nome: 'Voucher1010', tipo: VoucherTipo.Valor, valor: 5, inicio: '2024-05-22', conclusao: '2024-05-29' },
  { codigo: 'VOUCHER06', nome: 'VOUCHER 06', tipo: VoucherTipo.Valor, valor: 5, inicio: '2024-03-01', conclusao: '2024-04-30' },
  { codigo: 'VOUCHER05', nome: 'VOUCHER 05', tipo: VoucherTipo.Valor, valor: 5, inicio: '2024-03-01', conclusao: '2024-04-30' },
  { codigo: 'VOUCHER04', nome: 'VOUCHER 04', tipo: VoucherTipo.Valor, valor: 5, inicio: '2024-03-01', conclusao: '2024-04-30' },
  { codigo: '000003', nome: 'VOUCHER 03', tipo: VoucherTipo.Percentual, valor: 12, inicio: '2024-02-23', conclusao: '2024-03-20' },
  { codigo: '000002', nome: 'VOUCHER 02', tipo: VoucherTipo.Percentual, valor: 10, inicio: '2024-02-23', conclusao: '2024-03-20' },
];

// O cliente digita como quiser: com espaco sobrando, em minuscula, e o codigo
// "VOUCHER CH" tem espaco no meio de proposito.
function chave(codigo: string): string {
  return (codigo || '').trim().toUpperCase();
}

export function voucherCatalogoEncontra(codigo: string): Voucher | null {
  const procurado = chave(codigo);
  if (!procurado) {
    return null;
  }
  const achado = CATALOGO.find(v => chave(v.codigo) === procurado);
  if (!achado) {
    return null;
  }
  const voucher = new Voucher();
  Object.assign(voucher, achado);
  voucher.ativo = true;
  return voucher;
}
